import { defaultAgreementStatusSelectorFilter } from '~/hooks/useGetAgreements';
import { sortAlphabetically } from '~/infra/utils';
import { relationshipModel } from '~/models';
const SIGNED_AGREEMENT_STATUSES = new Set([
    relationshipModel.RelationshipStatus.Approved,
    relationshipModel.RelationshipStatus.Terminated
]);
export const formatBuyerLabel = (param)=>{
    let { firstName, lastName, email } = param;
    const name = [
        firstName,
        lastName
    ].filter((part)=>part != null && part !== '').join(' ');
    return name === '' ? email : "".concat(name, " (").concat(email, ")");
};
export const summaryBuyerLabel = (buyer)=>formatBuyerLabel({
        firstName: buyer.firstName,
        lastName: buyer.lastName,
        email: buyer.email
    });
const isSignedAgreement = (summary)=>SIGNED_AGREEMENT_STATUSES.has(summary.status);
const isBillableAgreement = (summary)=>isSignedAgreement(summary) && summary.agreementStatusV2 != null && defaultAgreementStatusSelectorFilter.includes(summary.agreementStatusV2);
export const splitBillableSummaries = (summaries)=>{
    var _summaries_find;
    return {
        agreements: summaries.filter(isBillableAgreement),
        adHocSummary: (_summaries_find = summaries.find((summary)=>!isSignedAgreement(summary))) !== null && _summaries_find !== void 0 ? _summaries_find : null
    };
};
export const toAgreementOptions = (agreements)=>sortAlphabetically(agreements.map((summary)=>({
            label: summary.title,
            value: summary.id
        })), 'label', {
        ascending: true,
        ignoreCase: true
    });
export const findAgreementSummary = (agreements, relationshipId)=>{
    var _agreements_find;
    return (_agreements_find = agreements.find((summary)=>summary.id === relationshipId)) !== null && _agreements_find !== void 0 ? _agreements_find : null;
};
